// @flow

import * as React from 'react';

import { FileText } from 'lucide-react';
import { Text, View } from 'reshaped';

import { selectCartUUID as selectCartId } from '@gandi/cart';

import { Button } from '@gandi/reshaped';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks';

export function PayLaterButton(): React.MixedElement {
  const { __ } = useTranslator();
  const cartId = useAppSelector(selectCartId);

  return (
    <View gap={1} align="center" width="100%">
      <Button
        size="large"
        color="primary"
        fullWidth
        variant="outline"
        to={`/cart/${cartId}/generate-proforma`}
        icon={FileText}
      >
        {__('Generate ProForma')}
      </Button>
      <Text variant="caption-1">
        {__('A proforma lets you pay after internal approval.')}
      </Text>
    </View>
  );
}
